import { ItemList } from '../orm'
import { get, head, size, map, filter, forEach } from 'lodash'
import moment from 'moment'
import { scaleImageFile, highResOptions, upload_to_aws_directly } from '../lib/image'

const DEFAULT_COUNTRY_CODE = "au"

const MAP_PLACEHOLDER_IMAGE_URL = null

class FileInfoList extends ItemList {
    getEntityKey() {
        return "file_info"
    }

    upload(file) {
      return async (dispatch, getState) => {
        const { s3_filepath } = await upload_to_aws_directly(file, DEFAULT_COUNTRY_CODE)
        return dispatch(this.saveNewObject({
          filename: file.name,
          aws_path: s3_filepath,
          country_code: DEFAULT_COUNTRY_CODE,
          content_type: file.type
        }))
      }
    }
}

export const fileInfoList = new FileInfoList("file_info_list__default")
